import { useState } from "react";
import styled from "styled-components";
import GooglePlacesAutocomplete from "./GooglePlacesAutocomplete";
import { ACTIVE_HEADER_VARIANT, HEADER_VARIANTS } from "../config/headerTheme";

/* ==============================
   STYLED COMPONENTS
============================== */

const AddressFlowContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  text-align: center;
  color: #292d32;

  h6 {
    font-size: 1.2rem;
    font-weight: 600;
    margin-bottom: 8px;
  }

  p {
    font-size: 0.9rem;
    color: #939696;
    margin-bottom: 15px;
  }
`;

const GridPlaces = styled.div`
  display: grid;
  grid-template-columns: auto 1fr;
  align-items: center;
  gap: 10px;
  width: 90%;
  max-width: 500px;
  margin: 0 auto;
  background: #fff;
  border-radius: 10px;
  padding: 15px;
`;

const IconWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;

  svg path {
    stroke: ${() => HEADER_VARIANTS[ACTIVE_HEADER_VARIANT].accent};
  }
`;

const RestoInfo = styled.div`
  margin-top: 10px;

  h6 {
    font-size: 1.1rem;
    font-weight: 600;
    margin: 5px 0;
  }

  p {
    font-size: 0.9rem;
    color: #555;
  }
`;

const ConfirmButton = styled.button`
  background: ${() => HEADER_VARIANTS[ACTIVE_HEADER_VARIANT].accent};
  color: #fff;
  border: none;
  border-radius: 50px;
  padding: 10px 25px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  margin-top: 15px;
  transition: 0.3s;

  &:hover {
    background: ${() => HEADER_VARIANTS[ACTIVE_HEADER_VARIANT].primary};
  }
`;

const ChangeLink = styled.a`
  color: ${() => HEADER_VARIANTS[ACTIVE_HEADER_VARIANT].accent};
  font-size: 0.9rem;
  text-decoration: none;
  font-weight: 500;
  margin-top: 10px;
  cursor: pointer;
`;

const CancelButton = styled.p`
  margin-top: 15px;
  font-size: 1rem;
  color: #afafaf;
  font-weight: 600;
  cursor: pointer;
`;

const Grid = styled.div`
    display: grid;
`


const AddressFlow = ({ onPlaceSelected = () => { }, canceUpdate }) => {
    const [step, setStep] = useState(false);
    const [restoName, setRestoName] = useState(null);
    const [restoAddress, setRestoAddress] = useState(null);
    const [input, setInput] = useState(null);

    const onChangePlace = (data) => {
        const { name, formatted_address } = data;
        setRestoName(name);
        setRestoAddress(formatted_address);
        setStep(true);
        setInput(data);
    };

    const confirm = () => {
        onPlaceSelected(input);
    };

    const cancel = () => {
        setRestoName(null);
        setRestoAddress(null);
        setInput(null);
        setStep(false);
    };

    return (
        <AddressFlowContainer>
            <div>
                <h6>¿Dónde trabajas?</h6>
                <p>Confirma el nombre del almacén donde trabajas.</p>
            </div>

            {!step ? (
                <GridPlaces>
                    <IconWrapper>
                        <svg
                            width="18"
                            height="21"
                            viewBox="0 0 18 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M6 9.32539C6 10.121 6.31607 10.8841 6.87868 11.4467C7.44129 12.0093 8.20435 12.3254 9 12.3254C9.79565 12.3254 10.5587 12.0093 11.1213 11.4467C11.6839 10.8841 12 10.121 12 9.32539C12 8.52974 11.6839 7.76668 11.1213 7.20407C10.5587 6.64146 9.79565 6.32539 9 6.32539C8.20435 6.32539 7.44129 6.64146 6.87868 7.20407C6.31607 7.76668 6 8.52974 6 9.32539Z"
                                stroke="#354052"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M14.657 14.9824L10.414 19.2254C10.039 19.6 9.53059 19.8105 9.0005 19.8105C8.47042 19.8105 7.96202 19.6 7.587 19.2254L3.343 14.9824C2.22422 13.8636 1.46234 12.4381 1.15369 10.8863C0.845043 9.33442 1.00349 7.72591 1.60901 6.26412C2.21452 4.80234 3.2399 3.55293 4.55548 2.6739C5.87107 1.79486 7.41777 1.32568 9 1.32568C10.5822 1.32568 12.1289 1.79486 13.4445 2.6739C14.7601 3.55293 15.7855 4.80234 16.391 6.26412C16.9965 7.72591 17.155 9.33442 16.8463 10.8863C16.5377 12.4381 15.7758 13.8636 14.657 14.9824Z"
                                stroke="#354052"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </IconWrapper>
                    <GooglePlacesAutocomplete onPlaceSelected={onChangePlace} />
                </GridPlaces>
            ) : (
                <Grid>
                    <IconWrapper>
                        <svg
                            width="18"
                            height="21"
                            viewBox="0 0 18 21"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                        >
                            <path
                                d="M6 9.32539C6 10.121 6.31607 10.8841 6.87868 11.4467C7.44129 12.0093 8.20435 12.3254 9 12.3254C9.79565 12.3254 10.5587 12.0093 11.1213 11.4467C11.6839 10.8841 12 10.121 12 9.32539C12 8.52974 11.6839 7.76668 11.1213 7.20407C10.5587 6.64146 9.79565 6.32539 9 6.32539C8.20435 6.32539 7.44129 6.64146 6.87868 7.20407C6.31607 7.76668 6 8.52974 6 9.32539Z"
                                stroke="#354052"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                            <path
                                d="M14.657 14.9824L10.414 19.2254C10.039 19.6 9.53059 19.8105 9.0005 19.8105C8.47042 19.8105 7.96202 19.6 7.587 19.2254L3.343 14.9824C2.22422 13.8636 1.46234 12.4381 1.15369 10.8863C0.845043 9.33442 1.00349 7.72591 1.60901 6.26412C2.21452 4.80234 3.2399 3.55293 4.55548 2.6739C5.87107 1.79486 7.41777 1.32568 9 1.32568C10.5822 1.32568 12.1289 1.79486 13.4445 2.6739C14.7601 3.55293 15.7855 4.80234 16.391 6.26412C16.9965 7.72591 17.155 9.33442 16.8463 10.8863C16.5377 12.4381 15.7758 13.8636 14.657 14.9824Z"
                                stroke="#354052"
                                strokeWidth="2"
                                strokeLinecap="round"
                                strokeLinejoin="round"
                            />
                        </svg>
                    </IconWrapper>

                    <RestoInfo>
                        <h6>{restoName}</h6>
                        <p>{restoAddress}</p>
                    </RestoInfo>

                    <ConfirmButton onClick={confirm}>Confirmar ubicación</ConfirmButton>
                    <ChangeLink onClick={cancel}>Cambiar</ChangeLink>
                </Grid>
            )}

            <CancelButton onClick={canceUpdate}>Cancelar</CancelButton>
        </AddressFlowContainer>
    );
};

export default AddressFlow;